
import { Component, Prop, Vue } from 'vue-property-decorator';
import ReassignmentPreview from '@/models/ReassignmentPreview';

/**
 * Shows the calculated financial impact of moving a driver between promoters
 * and asks the admin to confirm it.
 *
 * The amounts here are the ones that will actually be written: the preview
 * carries a planHash which the apply call re-derives and rejects on mismatch, so
 * a driver finishing another ride while this dialog is open can never turn into
 * a silently different number.
 */
@Component({})
export default class ReassignPromoterDialogComponent extends Vue {
    @Prop({ default: false })
    public showDialog!: boolean;

    @Prop({ default: false })
    public isLoading!: boolean;

    @Prop({ default: null })
    public preview!: ReassignmentPreview | null;

    public toAmount(value: number): string {
        const amount = value ?? 0;
        return `${amount < 0 ? '-' : ''}N$${Math.abs(amount).toFixed(2)}`;
    }

    public warningText(warning: string): string {
        return this.$t(`DRIVER.REASSIGN.WARNINGS.${warning}`).toString();
    }

    public confirmed() {
        this.$emit('confirmed');
    }

    public closed() {
        this.$emit('closed');
    }
}
